import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useStoreActions } from "easy-peasy";

import { verifySoftwareToken } from "../../api/verify-software-token";
import { notifyError } from "../../lib/notifications";

export const SendUserCode = () => {
  const [userCode, setUserCode] = useState("");
  const history = useHistory();
  const setIsAuthenticated = useStoreActions(
    (actions) => actions.setIsAuthenticated,
  );

  const userCodeNotProvided = () => (userCode === null || userCode.length === 0);

  const handleSubmit = (event) => {
    event.preventDefault();

    if(userCodeNotProvided()) {
      return notifyError("One time code missing");
    }

    const body = {
      user_code: userCode,
    };

    return verifySoftwareToken(body)
      .then((_res) => {
        setIsAuthenticated(true);
        return history.push("/applications");
      })
      .catch((error) => {
        if (!error.response) {
          return notifyError("Network error");
        }

        if (error.response.status === 400) {
          return notifyError("Wrong or expired code");
        }

        return notifyError("Something went wrong");
      });
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="flex flex-col gap-4 w-full"
    >
      <input
        className="bg-white border border-gray-200 rounded-md px-3 py-2 h-9 text-sm text-gray-500 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 shadow-sm"
        style={{ 
          borderColor: "#e5e5e5",
          color: "#737373",
        }}
        aria-label="user-code"
        placeholder="User code"
        value={userCode}
        onChange={(e) => setUserCode(e.target.value)}
        type="text"
      />
      <button
        type="submit"
        className="bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold rounded-md px-4 py-2 h-9 flex items-center justify-center transition-colors"
        style={{ 
          backgroundColor: "#2563eb",
        }}
        onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = "#1d4ed8"; }}
        onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "#2563eb"; }}
      >
        Send user code
      </button>
    </form>
  );
};
